module.exports = __webpack_public_path__ + "media/images/lightico-02d8f86894948a587f8fb43a4b687fa2.jpg";